import { createAction, props } from '@ngrx/store';

import {
  UnfreezeAccountResponse,
  FreezeNoticeResponse,
} from '../models/emergency-control.model';

// Unfreeze Account Actions
export const unfreezeAccount = createAction(
  '[Emergency Control] Unfreeze Account',
  props<{ reason: string }>()
);

export const unfreezeAccountSuccess = createAction(
  '[Emergency Control] Unfreeze Account Success',
  props<{ response: UnfreezeAccountResponse }>()
);

export const unfreezeAccountFailure = createAction(
  '[Emergency Control] Unfreeze Account Failure',
  props<{ error: string }>()
);

// Load Freeze Notice Actions
export const loadFreezeNotice = createAction(
  '[Emergency Control] Load Freeze Notice'
);

export const loadFreezeNoticeSuccess = createAction(
  '[Emergency Control] Load Freeze Notice Success',
  props<{ freezeNotice: FreezeNoticeResponse }>()
);

export const loadFreezeNoticeFailure = createAction(
  '[Emergency Control] Load Freeze Notice Failure',
  props<{ error: string }>()
);
